import React from "react";
import Flickity from "react-flickity-component";
import SliderStyle from "../../components/styles/slider";
type BlogSliderProps = {
  showPageDots?: boolean;
  children?: any;
  maxWidth?: string;
};

export const BlogSlider = ({
  showPageDots = false,
  children,
  maxWidth,
}: BlogSliderProps) => {
  const flickityOptions = {
    contain: true,
    groupCells: 2,
    cellAlign: "left",
    freeScroll: true,
    pageDots: showPageDots,
  };
  return (
    <div className="carousel-wrapper-blog">
      <div className="carousel-container-blog">
        <Flickity
          options={flickityOptions}
          className={"carousel"}
          elementType={"div"}
        >
          {children}
        </Flickity>
      </div>
      <SliderStyle />
      <style jsx global>
        {`
          .carousel-wrapper-blog {
            max-width: ${maxWidth ? maxWidth : "940px"};
            width: 100%;
            align-self: center;
            margin-bottom: 24px;
          }
          .flickity-page-dots {
            bottom: -25px;
          }

          @media only screen and (max-width: 600px) {
            .flickity-button {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
};
